import type { Card, CardValue, RuleOptions } from './types';

export const ROWS = 2;
export const COLS = 4;
export const SLOTS = ROWS * COLS;
/** Card values in ascending order. */
export const CARD_VALUES: readonly CardValue[] = [-5, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

/** How many copies of each value the deck holds (RULES.md 1 and 2). */
export function deckComposition(opts: Pick<RuleOptions, 'extendedDeck'>): Map<CardValue, number> {
  const m = new Map<CardValue, number>();
  for (const v of CARD_VALUES) {
    if (v === -5) m.set(v, opts.extendedDeck ? 6 : 4);
    else m.set(v, opts.extendedDeck ? 12 : 8);
  }
  return m;
}

/** A fresh, unshuffled deck: 108 cards (162 with extendedDeck), unique ids "value#copy". */
export function buildDeck(opts: Pick<RuleOptions, 'extendedDeck'>): Card[] {
  const out: Card[] = [];
  for (const [value, count] of deckComposition(opts)) {
    for (let i = 0; i < count; i++) out.push({ id: `${value}#${i}`, value });
  }
  return out;
}

export function columnOf(slot: number): number {
  return slot % COLS;
}

export function partnerOf(slot: number): number {
  return slot < COLS ? slot + COLS : slot - COLS;
}

export function maxPlayers(opts: Pick<RuleOptions, 'extendedDeck'>): number {
  return opts.extendedDeck ? 8 : 6;
}
